import React, { ReactElement, ReactNode, useState } from 'react';
import { Activite, Thematique } from '../../../../../common/src/entities';
import { ArrayHelpers, useFormikContext } from 'formik';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import CreerThematique from '../Thematiques/CreerThematique';
import TooltipSimple from '../../Common/TooltipSimple';
import { BiPencil, BiX } from 'react-icons/all';
import ChampMultipleDnd from './ChampMultipleDnd';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { cssTexte } from '../constantes';

function AffichageAjout(props: { helpers: ArrayHelpers; values: Thematique[] }): ReactElement {
    const [showModal, setShowModal] = useState(false);
    const formProps = {
        modal: true,
        succes: (t: Thematique) => {
            props.helpers.push(t);
            setShowModal(false);
        },
    };
    return (
        <>
            <Button variant="outline-primary" size="sm" onClick={() => setShowModal(true)}>
                Ajouter une thématique
            </Button>
            {/* modal création thématique */}
            <Modal
                scrollable
                show={showModal}
                onHide={() => {
                    setShowModal(false);
                }}
            >
                <CreerThematique {...formProps} {...props.values.length} />
            </Modal>
        </>
    );
}
const affichageAjout = (values: Thematique[], helpers: ArrayHelpers) => (
    <AffichageAjout helpers={helpers} values={values} />
);

const AffichageElement = (props: {
    value: Thematique;
    index: number;
    helpers: ArrayHelpers;
    affichageTexte: (value: Thematique) => ReactNode;
}): ReactElement => {
    const { value, index, helpers, affichageTexte } = props;
    const { setFieldValue, getFieldProps } = useFormikContext<Activite>();
    const { remove, replace } = helpers;
    const [showModal, setShowModal] = useState(false);
    const formProps = {
        id: value.id,
        ordrePriorite: value.ordreAffichage,
        valeursInitiales: value,
        modal: true,
        succes: (t: Thematique) => {
            replace(index, t);
            setShowModal(false);
        },
    };

    const toggleThematiqueEstPublic = (id) => {
        // Find the index of the thematique with the specified id
        const thematiques = getFieldProps('thematiques').value;
        const index = thematiques.findIndex((thematique) => thematique.id === id);

        if (index !== -1) {
            const newThematiques = [...thematiques];

            newThematiques[index] = {
                ...newThematiques[index],
                est_public: !newThematiques[index].est_public,
            };
            // Update the Formik field value for the thematiques array (this will trigger a re-render)
            setFieldValue('thematiques', [...newThematiques]);
        }
    };

    return (
        <Row>
            <Col className="d-flex align-items-center ml-2">
                <span style={cssTexte}>{affichageTexte(value)}</span>
            </Col>
            <Col xs="auto" className="category-actions mr-2">
                <Button variant="link" size="sm" onClick={() => setShowModal(true)}>
                    <BiPencil size="1.25em" />
                </Button>
                <Button
                    variant="link"
                    className="mr-2"
                    onClick={() => {
                        toggleThematiqueEstPublic(value.id);
                    }}
                >
                    {value.est_public ? (
                        <FiEye size="1.25em" />
                    ) : (
                        <FiEyeOff size="1.25em" style={{ color: 'gray' }}></FiEyeOff>
                    )}
                </Button>
                <TooltipSimple texte="Supprimer">
                    <Button
                        variant="link"
                        className="d-none d-sm-flex align-items-center text-muted px-0"
                        onClick={() => remove(index)}
                    >
                        <BiX size="1.25em" />
                    </Button>
                </TooltipSimple>
            </Col>
            {/* modal modification thématique */}
            <Modal
                scrollable
                show={showModal}
                onHide={() => {
                    setShowModal(false);
                }}
            >
                <CreerThematique {...formProps} />
            </Modal>
        </Row>
    );
};

const affichageElement = (
    value: Thematique,
    index: number,
    helpers: ArrayHelpers,
    affichageTexte: (value: Thematique) => ReactNode,
) => <AffichageElement {...{ value, index, helpers, affichageTexte }} />;

interface PropsChampMultipleThematique {
    id: string;
    labelCol?: number;
}

export default function ChampMultipleThematique(props: PropsChampMultipleThematique): ReactElement {
    return (
        <ChampMultipleDnd
            entite={Thematique}
            titre="Thématiques"
            {...props}
            affichageAjout={affichageAjout}
            affichageElement={(
                value: Thematique | number,
                index: number,
                helpers: ArrayHelpers,
                affichageTexte: (value: Thematique) => ReactNode,
            ) => affichageElement(value as Thematique, index, helpers, affichageTexte)}
            labelCol={props.labelCol}
        />
    );
}
